module.exports = __webpack_public_path__ + "0d84f3c7b937cf40328b4fd95cd0ba26.png";